<template>
  <div>
    <breadcrumb-header
      v-if="withBreadcrumbs"
      :items="breadcrumbs"
    />
    <v-expansion-panels
      v-if="store"
      v-model="panels"
      multiple
    >
      <v-expansion-panel
        color="primary"
        value="details"
      >
        <template #title>
          <div class="text-headline-small text-white">
            {{ t('store.info') }}
          </div>
        </template>
        <template #text>
          <rich-text-content
            v-if="store.details"
            :data="store.details"
            class="mb-5"
          />
          <store-marker
            v-if="showMap"
            v-model="store"
            read-only
          />
          <v-btn
            :href="`https://www.google.com/maps/dir/?api=1&destination=${store.lat},${store.lng}`"
            target="_blank"
            prepend-icon="fas fa-compass"
            :text="t('global.directions')"
            color="primary"
            :class="smAndDown ? 'mt-1' : ''"
            class="me-1"
            size="large"
          />
        </template>
      </v-expansion-panel>
      <v-expansion-panel
        v-if="store?.images?.length"
        color="primary"
        value="gallery"
      >
        <template #title>
          <div class="text-headline-small text-white">
            {{ t('images.gallery') }}
          </div>
        </template>

        <template #text>
          <image-gallery
            v-if="store.images?.length"
            v-model="store.images"
            enable-slide-show
            read-only
          />
        </template>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script setup lang="ts">
import axios from 'axios';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useDisplay } from 'vuetify';
import RichTextContent from '@/components/rich-text/RichTextContent.vue';
import { useErrorStore } from '@/stores/errors';
import ImageGallery from '../images/ImageGallery.vue';
import StoreMarker from './StoreMarker.vue';

const props = withDefaults(defineProps<{
  id: string | number;
  withBreadcrumbs?: boolean;
  showMap?: boolean;
}>(), {
  withBreadcrumbs: () => true,
  showMap: () => true,
});

const { smAndDown } = useDisplay();
const { t } = useI18n();
const { handleError } = useErrorStore();
const store = ref<App.Models.Store | null>();
const panels = ref(['details']);
const breadcrumbs = computed(() => [
  {
    title: t('store.and_locations'),
    to: '/locations',
  },
  {
    title: store.value?.name ?? t('states.loading'),
  },
]);

async function loadStore() {
  try {
    const response = await axios.get(`/api/stores/${props.id}?inc[]=images`);
    store.value = response.data.data;
  }
  catch (error) {
    handleError(error, t('store.cannot_load'));
  }
}

loadStore();
</script>
